// extracted by mini-css-extract-plugin
export default {"advertDetailHeaderPrice":"c-n_fR","advertDetailHeaderPrice__value":"c-n_fS","advertDetailHeaderPrice__label":"c-n_fT"};